import { ga } from 'js/analytics/adapters'

export const trackPageView = () => {
  ga.page({
    url: document.location.href,
    pathname: document.location.pathname,
    title: document.title,
  })
}
